import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPlanStatus,
  resetPlanStatusFetched,
  planStatusErrorSelector,
  planStatusLoadingSelector,
  planStatusSelector
} from '../redux/features/plan/plansSlice';

/**
 * Custom hook to fetch and manage user's plan status using Redux.
 * Fetches current plan information including expiry and available upgrades.
 *
 * @returns {Object} planStatus, loading, error, refreshPlanStatus
 */
export const usePlanStatus = () => {
  const dispatch = useDispatch();
  const planStatus = useSelector(planStatusSelector);
  const loading = useSelector(planStatusLoadingSelector);
  const error = useSelector(planStatusErrorSelector);

  // Fetch plan status on mount
  useEffect(() => {
    console.log('🔄 [usePlanStatus] Dispatching fetchPlanStatus thunk');
    dispatch(fetchPlanStatus());
  }, [dispatch]);

  // Expose refresh function for manual refresh (e.g., after payment)
  const refreshPlanStatus = useCallback(() => {
    console.log('🔄 [usePlanStatus] Manual refresh triggered - resetting fetch flag');
    dispatch(resetPlanStatusFetched()); // Reset flag first to bypass hasFetched guard
    dispatch(fetchPlanStatus()); // Then fetch fresh data
  }, [dispatch]);

  return {
    planStatus,
    loading,
    error,
    refreshPlanStatus
  };
};
